import axios from '../axios';
// 采购订单列表
export const getPurOrderPage = data => {
  return axios({
    url: '/api/sys/pur/getPurOrderPage',
    method: 'post',
    data
  })
};
// 采购订单总合计
export const getPurOrderSum = data => {
  return axios({
    url: '/api/sys/pur/getPurOrderSum',
    method: 'post',
    data
  })
};
// 采购订单列表审核
export const audit = data => {
  return axios({
    url: '/api/sys/pur/audit',
    method: 'post',
    data
  })
};
// 采购订单列表反审核
export const unAudit = data => {
  return axios({
    url: '/api/sys/pur/unAudit',
    method: 'post',
    data
  })
};
// 采购订单列表删除
export const deletePurOrders = data => {
  return axios({
    url: '/api/sys/pur/deletePurOrders',
    method: 'post',
    data
  })
};
// 采购订单列表作废
export const invalidOrder = data => {
  return axios({
    url: '/api/sys/pur/invalidOrder',
    method: 'post',
    data
  })
};
// 采购订单列表关闭
export const closeOrder = data => {
  return axios({
    url: '/api/sys/pur/closeOrder',
    method: 'post',
    data
  })
};
// 采购订单列表保存
export const savePurOrder = data => {
  if (!data.billId) {//保存
    return axios({
      url: '/api/sys/pur/savePurOrder',
      method: 'post',
      data
    })
  } else {//修改
    return axios({
      url: '/api/sys/pur/updatePurOrder',
      method: 'post',
      data
    })
  }
};

// 采购订单明细列表
export const getPurOrderEntryPage = data => {
  return axios({
    url: '/api/sys/pur/getPurOrderEntryPage',
    method: 'post',
    data
  })
};
// 采购订单明细列表删除
export const deletePurOrderEntrys = data => {
  return axios({
    url: '/api/sys/pur/deletePurOrderEntrys',
    method: 'post',
    data
  })
};
// 采购订单明细列表保存
export const savePurOrderEntry = data => {
  return axios({
    url: '/api/sys/pur/savePurOrderEntry',
    method: 'post',
    data
  })
};
// 采购订单明细列表修改
export const updatePurOrderEntry = data => {
  return axios({
    url: '/api/sys/pur/updatePurOrderEntry',
    method: 'post',
    data
  })
};

// 送货单列表
export const getPurArrivalPage = data => {
  return axios({
    url: '/api/sys/pur/getPurArrivalPage',
    method: 'post',
    data
  })
};
// 送货单总合计
export const getPurArrivalSum = data => {
  return axios({
    url: '/api/sys/pur/getPurArrivalSum',
    method: 'post',
    data
  })
};
// 送货单列表保存
export const savePurArrival = data => {
  return axios({
    url: '/api/sys/pur/savePurArrival',
    method: 'post',
    data
  })
};
// 送货单列表删除
export const deletePurArrivals = data => {
  return axios({
    url: '/api/sys/pur/deletePurArrivals',
    method: 'post',
    data
  })
};
// 送货单列表审核
export const auditArrival = data => {
  return axios({
    url: '/api/sys/pur/auditArrival',
    method: 'post',
    data
  })
};
// 送货单列表船运完成
export const achieve = data => {
  return axios({
    url: '/api/sys/pur/achieve',
    method: 'post',
    data
  })
};
// 送货单列表作废
export const invalidArrival = data => {
  return axios({
    url: '/api/sys/pur/invalidArrival',
    method: 'post',
    data
  })
};
// 送货单列表关闭
export const closeArrival = data => {
  return axios({
    url: '/api/sys/pur/closeArrival',
    method: 'post',
    data
  })
};
// 送货单车辆列表
export const getPurArrivalCarPage = data => {
  return axios({
    url: '/api/sys/pur/getPurArrivalCarPage',
    method: 'post',
    data
  })
};
// 送货单车辆列表保存
export const savePurArrivalCar = data => {
  return axios({
    url: '/api/sys/pur/savePurArrivalCar',
    method: 'post',
    data
  })
};
// 送货单车辆列表删除
export const deletePurArrivalCars = data => {
  return axios({
    url: '/api/sys/pur/deletePurArrivalCars',
    method: 'post',
    data
  })
};
// 地磅设备维护列表
export const getBaseLoadometerPage = data => {
  return axios({
    url: '/api/sys/base/getBaseLoadometerPage',
    method: 'post',
    data
  })
};
// 送货单一次过磅
export const onceWeigh = data => {
  return axios({
    url: '/api/sys/pur/onceWeigh',
    method: 'post',
    data
  })
};
// 送货单二次过磅
export const twiceWeigh = data => {
  return axios({
    url: '/api/sys/pur/twiceWeigh',
    method: 'post',
    data
  })
};
// 送货单二次过磅(修改)
export const updatePurArrivalEntry = data => {
  return axios({
    url: '/api/sys/pur/updatePurArrivalEntry',
    method: 'post',
    data
  })
};
// 送货单明细列表（用于二次称重的列表）
export const getPurArrivalEntryPage = data => {
  return axios({
    url: '/api/sys/pur/getPurArrivalEntryPage',
    method: 'post',
    data
  })
};
// 采购入库单列表
export const getStkInPurchasePage = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchasePage',
    method: 'post',
    data
  })
};
// 采购入库单总合计
export const getStkInPurchaseSum = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchaseSum',
    method: 'post',
    data
  })
};
// 采购入库单列表保存
export const saveStkInPurchase = data => {
  return axios({
    url: '/api/sys/stk/saveStkInPurchase',
    method: 'post',
    data
  })
};
// 采购入库单列表修改
export const updateStkInPurchase = data => {
  return axios({
    url: '/api/sys/stk/updateStkInPurchase',
    method: 'post',
    data
  })
};
// 采购入库单列表审核
export const stkAudit = data => {
  return axios({
    url: '/api/sys/stk/audit',
    method: 'post',
    data
  })
};
// 采购入库单列表反审核
export const stkUnAudit = data => {
  return axios({
    url: '/api/sys/stk/unAudit',
    method: 'post',
    data
  })
};
// 采购入库单列表删除
export const deleteStkInPurchases = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInPurchases',
    method: 'post',
    data
  })
};
// 采购入库单明细列表
export const getStkInPurchaseEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInPurchaseEntryPage',
    method: 'post',
    data
  })
};
// 采购结算
export const purchaseSettle = data => {
  return axios({
    url: '/api/sys/stk/purchaseSettle',
    method: 'post',
    data
  })
};
// 采购反结算
export const unPurchaseSettle = data => {
  return axios({
    url: '/api/sys/stk/unPurchaseSettle',
    method: 'post',
    data
  })
};
// 获取质检指标单价扣减
export const getQualityStandardList = data => {
  return axios({
    url: '/api/sys/stk/getQualityStandardList',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/moudules/OrderPurchase.js